import { format } from "date-fns";
import React from "react";
import { Link } from "react-router-dom";

const subscriptionsMigrationsListColumns = [
  {
    name: "Ação",
    selector: row => (
      <Link target="_self" to={`/subscription_migration/${row.id}`}>
        <button type="button" className="btn btn-icon btn-primary">
          <i className="flaticon-eye"></i>
        </button>
      </Link>
    ),
    width: "70px"
  },
  {
    name: "Cadastrado em",
    selector: row => row.created_at,
    width: "150px",
    cell: row => (
      <div>
        {row.created_at ? format(new Date(row.created_at), "dd/MM/yyyy HH:mm") : "Data indisponível"}
      </div>
    ),
    sortable: true
  },
  {
    name: "Plano Atual",
    selector: row => row?.old_plan ? row.old_plan.name : "-",
    maxWidth: "300px",
    sortable: true
  },
  {
    name: "Preço Atual",
    selector: row => row?.old_plan ? `R$${row.old_plan.amount}` : "-",
    maxWidth: "120px",
    sortable: true
  },
  {
    name: "Novo Plano",
    selector: row => row?.new_plan ? row.new_plan.name : "-",
    maxWidth: "300px",
    sortable: true
  },
  {
    name: "Novo Preço",
    selector: row => row?.new_plan ? `R$${row.new_plan.amount}` : "-",
    maxWidth: "120px",
    sortable: true
  },
  {
    name: "Dias para Migração",
    selector: row => row.after_days ?? "Não especificado",
    maxWidth: "180px",
    sortable: true
  },
];

export { subscriptionsMigrationsListColumns };
